import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Backdrop, Button, Grid, InputAdornment, MenuItem, Select, TextField, Typography } from '@mui/material';
import AppLoader from '../../../../components/AppLoader/AppLoader';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Box } from '@mui/system';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import { AllRoles } from '../../../../network/APIs/APIs';
import { cfpBaseUrl } from '../../../../network/urls';
import { allCompaniesAPI, documentValidation, allEmployeeRoleTypes, allCFCLevelsAPI } from '../../../../services/Functions';
import './UpdateUser.scss';
import Error from '../../../../components/error/error';
import UserIconImage from '../../../../images/user.jpg';

const UserUpdateForm = () => {


  const [cfcLevelList, setCFCLevelList] = useState([]);
  const [file, setFile] = useState('');
  const [fileThumbnail, setFileThumbnail] = useState('');
  const [viewBackdrop, setViewBackdrop] = React.useState(false);
  const [userState, setUserState] = useState();
  const [formvalues, setFormValues] = useState();
  const { state } = useLocation();
  const { userToEdit } = state;

  const [companyList, setCompanyList] = useState([]);
  const [allRoles, setAllRoles] = useState();
  const [hierarchyList, setHierarchyList] = useState([]);
  const [cfcsList, setcfcsList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subdivisionList, setsubDivisionList] = useState([]);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [error, setError] = useState('');
  const [employeeType, setEmployeeType] = useState()
  const [selectedRoleType, setSelectedRoleType] = useState("");
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isRoleManuallyChanged, setIsRoleManuallyChanged] = useState(false);

  const [technicalLevels, setTechnicalLevels] = useState([{
    value: 1,
    label: 'PITC'
  }, {
    value: 2,
    label: 'DISCO'
  }, {
    value: 3,
    label: 'Circle'
  }, {
    value: 4,
    label: 'Division'
  }, {
    value: 52,
    label: 'Sub Division'
  }])
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
  const handleMouseDownConfirmPassword = (event) => {
    event.preventDefault();
  };
  useEffect(() => {
    if (userToEdit && userToEdit.roleTypeId) {
      setSelectedRoleType(userToEdit.roleTypeId.toString());
      setSelectedRoleId(userToEdit.role_id.toString());
      setSelectedStatus(userToEdit.status);
    }
  }, [userToEdit]);
  useEffect(() => {
    const callCFCLevels = async () => {
      setViewBackdrop(true)
      let cfcLevelsList = await allCFCLevelsAPI(token, cfpBaseUrl)
      if (cfcLevelsList) {
        if (hierarchy != 1) {
          cfcLevelsList = cfcLevelsList.filter(item => parseInt(item.cfcLevelId) >= parseInt(hierarchy))
        }
        setCFCLevelList(cfcLevelsList)
      }
      setViewBackdrop(false);
    }
    callCFCLevels()
  }, [])
  useEffect(() => {
  }, [selectedRoleId])
  const navigate = useNavigate()
  const initialValues = {
    iv_office_code: '',
    iv_level: '',
    iv_full_name: '',
    iv_user_name: '',
    // Iv_roleType:'',
    // iv_pin_code: '',
    // iv_password: '',
    // iv_confirm_password: '',
    iv_email: '',
    iv_phone_no: '',
    iv_cnic: '',
    iv_role: selectedRoleId || '',
    iv_company: '',
    iv_circle: '',
    iv_division: '',
    iv_support_center: '',
    iv_sub_division: '',
    // iv_status: 1,
    iv_picture: ''
  }
  let { token, code: userOfficeCode, userId: updatedBy, permissions, hierarchy } = useSelector((state) => state.auth)
  let userCompany = userOfficeCode.slice(0, 2);

  useEffect(() => {
    const callAllCompanies = async () => {
      setViewBackdrop(true)
      let companiesList = await allCompaniesAPI(token, cfpBaseUrl)
      if (companiesList) {
        companiesList = companiesList.filter(item => item.companyCode != 1)
        let cpList = companiesList.map(item => ({
          code: item.companyCode,
          name: item.companyName
        }))
        cpList.unshift({ code: 10, name: 'PITC' })
        setCompanyList(cpList)
      }
      setViewBackdrop(false);
    }
    callAllCompanies()
  }, [])

  useEffect(() => {
    setUserState(userToEdit)
  }, [userToEdit])
  useEffect(() => {
    const getAllEmployeeRoleTypes = async () => {
      setViewBackdrop(true)
      let employeeRoleTypes = await allEmployeeRoleTypes(token, cfpBaseUrl)
      if (employeeRoleTypes) {
        setEmployeeType(employeeRoleTypes)
      }
      setViewBackdrop(false);
    }
    getAllEmployeeRoleTypes()
  }, [])
  useEffect(() => {
    const getAllRoles = async () => {
      let allroles = await AllRoles(token, permissions)
      setAllRoles(allroles)
    }
    getAllRoles()
  }, [])

  const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue } = useFormik({

    initialValues,
    validationSchema: Yup.object({
      iv_office_code: Yup.string().optional(),
      iv_level: Yup.mixed().required('Level is required'),
      // iv_status: Yup.mixed().optional('Status is required'),
      iv_full_name: Yup.string().required("Fullname is required").min(3, `Name can't be less than 3 characters!`).max(50, `Name can't be more than 50 characters!`),
      iv_user_name: Yup.string().required("Username is required"),
      // Iv_roleType: Yup.string().required("Employee Type is required"),
      // iv_pin_code: Yup.number().typeError("Pincode must be in number").optional(),
      // iv_password: Yup.string().min(8, "Password can't be less than 8 characters!").max(16, 'Password can not be more than 16 digits!').required("Password is required"),
      // iv_password: Yup.string()
      //   .required("Password is required")
      //   .test("len", "Password must be between 8 and 16 characters", val =>
      //     val && val.length >= 8 && val.length <= 16
      //   )
      //   .test("lowercase", "At least 1 lowercase letter required", val =>
      //     /[a-z]/.test(val)
      //   )
      //   .test("uppercase", "At least 1 uppercase letter required", val =>
      //     /[A-Z]/.test(val)
      //   )
      //   .test("number", "At least 1 number required", val =>
      //     /[0-9]/.test(val)
      //   )
      //   .test("special", "At least 1 special character required", val =>
      //     /[^A-Za-z0-9]/.test(val)
      //   ),
      // iv_confirm_password: Yup.string().oneOf([Yup.ref('iv_password'), null], 'Password and Confirm password must match').optional("Confirm password is required"),
      iv_email: Yup.string().email('Enter valid email!').required("Email is required"),
      iv_phone_no: Yup.string().min(11, "Phone no. can not less than 11 digits.").max(11, "Phone no. can not greater than 11 digits.").required("Phone no. is required").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone no. as 03001234567."),
      iv_cnic: Yup.string().min(13, "CNIC no. can not less than 13 digits.").max(13, "CNIC no. can not greater than 13 digits.").required("CNIC No. is required").matches(/^[0-9]+$/, "Enter CNIC No. as 3520212345678"),
      iv_role: Yup.mixed().required('Role is required'),
      iv_company: Yup.string().when('iv_level', {
        is: (value) => value > 1,
        then: Yup.string().required("Company is required!"),
        otherwise: Yup.string().optional()
      }),
      iv_circle: Yup.string().when('iv_level', {
        is: (value) => value > 2,
        then: Yup.string().required("Circle is required!"),
        otherwise: Yup.string().optional()
      }),
      iv_division: Yup.string().when('iv_level', {
        is: (value) => value > 3,
        then: Yup.string().required("Division is required!"),
        otherwise: Yup.string().optional()
      }),
      // iv_support_center: Yup.string().when('iv_level', {
      //   is: (value) => value == 51,
      //   then: Yup.string().required("Customer Support Center is required!"),
      //   otherwise: Yup.string().optional()
      // }),
      iv_sub_division: Yup.string().when('iv_level', {
        is: (value) => value == 52,
        then: Yup.string().required("Sub division is required!"),
        otherwise: Yup.string().optional()
      }),
    }),

    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      var formdata = new FormData();

      formdata.append("toBeUpdatedUserId", values.iv_user_name);
      formdata.append("name", values.iv_full_name);
      formdata.append("code", values.iv_company == "0" ? values.iv_office_code.toString().slice(0, 2) : values.iv_office_code);
      formdata.append("phoneNo", values.iv_phone_no);
      formdata.append("email", values.iv_email);
      // formdata.append("password", values.iv_password);
      formdata.append("role_id", values.iv_role);
      formdata.append("pin_code", "0000");
      formdata.append("updated_By", updatedBy);
      formdata.append("hierarchy", values.iv_level);
      formdata.append("companyCode", values.iv_company);
      formdata.append("circleCode", values.iv_circle);
      formdata.append("divisionCode", values.iv_division);
      formdata.append("subDivisionCode", values.iv_sub_division);
      formdata.append("cscId", values.iv_support_center);
      formdata.append("status", values.iv_status);
      formdata.append("cnic", values.iv_cnic);
      formdata.append("profilePicture", file);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;


      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "customerFaciliationPortal/updateUser", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === '200') {
            navigate('/user-management')
          } else {
            setError(result.message)
          }
        });
      setViewBackdrop(false);

    }
  })

  useEffect(() => {
    if (hierarchy != 1) {
      let hierarchyArray = technicalLevels
      setTechnicalLevels(hierarchyArray.filter(item => item.value >= parseInt(hierarchy)))
      values.iv_company = userCompany
    }
  }, [hierarchy, userCompany])

  useEffect(() => {
    const AllCFCSAPI = async () => {
      setViewBackdrop(true)
      try {
        var formdata = new FormData();
        if (userOfficeCode == 10) {
          formdata.append("companyCode", '');
        } else {
          formdata.append("companyCode", parseInt(userOfficeCode.toString().slice(0, 2)));
        }
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow',
        };
        await fetch(cfpBaseUrl + "customerFaciliationPortal/getAllCFCs", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status === '200') {
              const allcfcs = result.data
              const filteredList = allcfcs.filter(cfc => cfc.cfcId.toString().substring(0, 4) == values.iv_division);
              if (cfcsList) {
                setcfcsList(filteredList)
              }
            }
          })
          .catch(() => {});
      }
      catch (e) {
      }
      setViewBackdrop(false)
    }
    AllCFCSAPI()
  }, [values.iv_division])

  useEffect(() => {
    if (userState) {
      values.iv_office_code = userState.code
      values.iv_level = userState.hierarchy
      values.iv_full_name = userState.name
      values.iv_user_name = userState.userId
      values.iv_email = userState.email
      values.iv_phone_no = userState.phoneNo
      values.iv_cnic = userState.CNIC
      values.iv_role = userState.role_id
      values.iv_company = userState.companyCode
      values.iv_circle = userState.circleCode
      values.iv_division = userState.divisionCode
      values.iv_support_center = userState.cscId
      values.iv_sub_division = userState.subDivisionCode
      values.iv_status = userState.status
      values.iv_picture = userState.profilePicture
      setFileThumbnail(userState.profilePicture)
      var formdata = new FormData();
      formdata.append("companyCode", parseInt(userState.companyCode));
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };
      fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions)
        .then(response => response.json())
        .then(result => {
          let hierarchyArray = result.message
          let sortedSdArray = hierarchyArray.sort(function (a, b) {
            var sdA = a.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
            var sdB = b.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
            if (sdA < sdB) {
              return -1; // nameA comes before nameB in the sorted order
            }
            if (sdA > sdB) {
              return 1; // nameA comes after nameB in the sorted order

            }
            return 0; // names are equal, their order doesn't matter
          });

          let uniqueCircles = []
          for (let i = 0; i < sortedSdArray.length; i++) {
            const circle = sortedSdArray[i];
            const existingCircle = uniqueCircles.find(c => c.code === circle.circleCode);
            if (!existingCircle) {
              uniqueCircles.push({
                code: circle.circleCode,
                name: circle.circleName
              });
            }
          }

          let sortedCircleArray = uniqueCircles.sort(function (a, b) {
            var circleA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
            var circleB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
            if (circleA < circleB) {
              return -1; // nameA comes before nameB in the sorted order
            }
            if (circleA > circleB) {
              return 1; // nameA comes after nameB in the sorted order
            }
            return 0; // names are equal, their order doesn't matter
          });

          let uniqueDivisions = []
          for (let i = 0; i < sortedSdArray.length; i++) {
            const division = sortedSdArray[i];
            if (division.circleCode === userState.circleCode) {
              const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
              if (!existingDivision) {
                uniqueDivisions.push({
                  code: division.divisionCode,
                  name: division.divisionName
                });
              }
            }
          }

          let sortedDivisionArray = uniqueDivisions.sort(function (a, b) {
            var divisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
            var divisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
            if (divisionA < divisionB) {
              return -1; // nameA comes before nameB in the sorted order
            }
            if (divisionA > divisionB) {
              return 1; // nameA comes after nameB in the sorted order
            }
            return 0; // names are equal, their order doesn't matter
          });

          let uniquesubDivisions = []
          for (let i = 0; i < sortedSdArray.length; i++) {
            const subdivision = sortedSdArray[i];
            if (subdivision.divisionCode === userState.divisionCode) {
              const existingsubDivision = uniquesubDivisions.find(c => c.code === subdivision.subDivisionCode);
              if (!existingsubDivision) {
                uniquesubDivisions.push({
                  code: subdivision.subDivisionCode,
                  name: subdivision.subDivisionName
                });
              }
            }
          }

          let sortedsubDivisionArray = uniquesubDivisions.sort(function (a, b) {
            var subdivisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
            var subdivisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
            if (subdivisionA < subdivisionB) {
              return -1; // nameA comes before nameB in the sorted order
            }
            if (subdivisionA > subdivisionB) {
              return 1; // nameA comes after nameB in the sorted order
            }
            return 0; // names are equal, their order doesn't matter
          });

          let filteredList = cfcsList.filter(cfc => cfc.cfcId.toString().substring(0, 4) == userState.divisionCode);
          if (cfcsList) {
            setcfcsList(filteredList)
          }

          setHierarchyList(sortedSdArray)
          setCircleList(sortedCircleArray)
          setDivisionList(sortedDivisionArray)
          setsubDivisionList(sortedsubDivisionArray)
        }
        )
        .catch(() => {});
    }
  }, [userState])


  useEffect(() => {
    if (file) {
      values.iv_picture = fileThumbnail
    }
  }, [file])

  const handleChangeCompany = (event) => {
    handleChange(event); // update the value state with the selected value
    values.iv_office_code = event.target.value;
    if (values.iv_level >= 3) {
      values.iv_circle = '';
    }
    else {
      values.iv_circle = 0;
    }
    if (values.iv_level >= 4) {
      values.iv_division = '';
    }
    else {
      values.iv_division = 0;
    }
    if (values.iv_level === 51) {
      values.iv_support_center = '';
    }
    else {
      values.iv_support_center = 0;
    }
    if (values.iv_level === 52) {
      values.iv_sub_division = '';
    }
    else {
      values.iv_sub_division = 0;
    }
    var formdata = new FormData();
    formdata.append("companyCode", event.target.value);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);;
    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    };

    fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions)
      .then(response => response.json())
      .then(result => {
        let hierarchyArray = result.message
        let sortedSdArray = hierarchyArray.sort(function (a, b) {
          var sdA = a.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
          var sdB = b.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
          if (sdA < sdB) {
            return -1; // nameA comes before nameB in the sorted order
          }
          if (sdA > sdB) {
            return 1; // nameA comes after nameB in the sorted order

          }
          return 0; // names are equal, their order doesn't matter
        });
        setHierarchyList(sortedSdArray)
        // handleChange(event.target.value);
      }
      )
      .catch(() => {});
  };

  useEffect(() => {
    if (hierarchyList) {
      let hierarchyArray = hierarchyList
      let uniqueCircles = []
      for (let i = 0; i < hierarchyArray.length; i++) {
        const circle = hierarchyArray[i];
        const existingCircle = uniqueCircles.find(c => c.code === circle.circleCode);
        if (!existingCircle) {
          uniqueCircles.push({
            code: circle.circleCode,
            name: circle.circleName
          });
        }
      }

      let sortedCircleArray = uniqueCircles.sort(function (a, b) {
        var circleA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var circleB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (circleA < circleB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (circleA > circleB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      setCircleList(sortedCircleArray)
    }
  }, [hierarchyList])

  const handleChangeCircle = (event) => {
    handleChange(event);
    const selectedCircle = circleList.find((item) => item.code === event.target.value); // find the selected circle object in the circleList array using the selected value
    if (selectedCircle) {
      values.iv_office_code = selectedCircle.code;
    }
    if (values.iv_level >= 4) {
      values.iv_division = '';
    }
    else {
      values.iv_division = 0;
    }
    if (values.iv_level === 51) {
      values.iv_support_center = '';
    }
    else {
      values.iv_support_center = 0;
    }
    if (values.iv_level === 52) {
      values.iv_sub_division = '';
    }
    else {
      values.iv_sub_division = 0;
    }
  };

  useEffect(() => {
    if (values.iv_circle) {
      let hierarchyArray = hierarchyList
      let uniqueDivisions = []
      for (let i = 0; i < hierarchyArray.length; i++) {
        const division = hierarchyArray[i];
        if (division.circleCode === values.iv_circle) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort(function (a, b) {
        var divisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var divisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (divisionA < divisionB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (divisionA > divisionB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      setDivisionList(sortedDivisionArray)
    }
  }, [values.iv_circle])

  const handleChangeDivision = (event) => {
    handleChange(event);
    const selecteddivion = divisionList.find((item) => item.code === event.target.value); // find the selected circle object in the circleList array using the selected value
    if (selecteddivion) {
      values.iv_office_code = selecteddivion.code;
    }
    if (values.iv_level === 51) {
      values.iv_support_center = '';
    }
    else {
      values.iv_support_center = 0;
    }
    if (values.iv_level === 52) {
      values.iv_sub_division = '';
    }
    else {
      values.iv_sub_division = 0;
    }
  };

  useEffect(() => {
    if (values.iv_division) {
      let hierarchyArray = hierarchyList
      let uniquesubDivisions = []
      for (let i = 0; i < hierarchyArray.length; i++) {
        const subdivision = hierarchyArray[i];
        if (subdivision.divisionCode === values.iv_division) {
          const existingsubDivision = uniquesubDivisions.find(c => c.code === subdivision.subDivisionCode);
          if (!existingsubDivision) {
            uniquesubDivisions.push({
              code: subdivision.subDivisionCode,
              name: subdivision.subDivisionName
            });
          }
        }
      }


      let sortedsubDivisionArray = uniquesubDivisions.sort(function (a, b) {
        var subdivisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        var subdivisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
        if (subdivisionA < subdivisionB) {
          return -1; // nameA comes before nameB in the sorted order
        }
        if (subdivisionA > subdivisionB) {
          return 1; // nameA comes after nameB in the sorted order
        }
        return 0; // names are equal, their order doesn't matter
      });
      const filteredList = cfcsList.filter(cfc => cfc.cfcId.toString().substring(0, 4) == values.iv_division);
      if (cfcsList) {
        setcfcsList(filteredList)
      }
      setsubDivisionList(sortedsubDivisionArray)
    }
  }, [values.iv_division])

  // const handleLevelChange = (event) => {
  //   handleChange(event)
  //   if (hierarchy == 1) {
  //     values.iv_role = '';
  //     if (event.target.value === 1) {
  //       values.iv_company = 1
  //       values.iv_circle = 0
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = event.target.value
  //     }
  //     else if (event.target.value === 2) {
  //       values.iv_company = ''
  //       values.iv_circle = 0
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = 0
  //     }
  //     else if (event.target.value === 3) {
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //       }
  //       values.iv_circle = ''
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = ''
  //     }
  //     else if (event.target.value === 4) {
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //       }
  //       values.iv_division = ''
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = ''
  //     }
  //     else if (event.target.value === 51) {
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //       }
  //       values.iv_support_center = ''
  //       values.iv_sub_division = 0
  //       values.iv_office_code = ''
  //     }
  //     else if (event.target.value === 52) {
  //       if (values.iv_company === 1) {
  //         values.iv_company = ''
  //       }
  //       values.iv_support_center = 0
  //       values.iv_sub_division = ''
  //       values.iv_office_code = ''
  //     }
  //   } else {
  //     if (event.target.value === 2) {
  //       values.iv_company = userCompany
  //       values.iv_circle = 0
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = userCompany
  //     }
  //     else if (event.target.value === 3) {
  //       values.iv_company = userCompany
  //       values.iv_circle = ''
  //       values.iv_division = 0
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = userCompany
  //     }
  //     else if (event.target.value === 4) {
  //       values.iv_company = userCompany
  //       values.iv_division = ''
  //       values.iv_support_center = 0
  //       values.iv_sub_division = 0
  //       values.iv_office_code = userCompany
  //     }
  //     else if (event.target.value === 52) {
  //       values.iv_company = userCompany
  //       values.iv_support_center = 0
  //       values.iv_sub_division = ''
  //       values.iv_office_code = userCompany
  //     }
  //   }
  // }
  const handleLevelChange = (event) => {
    // values.iv_level = event.target.value
    handleChange(event)
    values.iv_role = '';
    if (event.target.value === 1) {
      values.iv_company = 1
      values.iv_circle = 0
      values.iv_division = 0
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = event.target.value
      values.iv_level = 1;
    }
    else if (event.target.value === 2) {
      // values.iv_company = ''
      values.iv_circle = 0
      values.iv_division = 0
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = 0
      // setcompanycode('');
    }
    else if (event.target.value === 3) {
      if (values.iv_company === 1) {
        values.iv_company = ''
      }
      values.iv_circle = ''
      values.iv_division = 0
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = ''
    }
    else if (event.target.value === 4) {
      if (values.iv_company === 1) {
        values.iv_company = ''
      }
      values.iv_division = ''
      values.iv_support_center = 0
      values.iv_sub_division = 0
      values.iv_office_code = ''
    }
    else if (event.target.value === 51) {
      if (values.iv_company === 1) {
        values.iv_company = ''
      }
      values.iv_support_center = ''
      values.iv_sub_division = 0
      values.iv_office_code = ''
    }
    else if (event.target.value === 52) {
      if (values.iv_company === 1) {
        values.iv_company = ''
      }
      values.iv_support_center = 0
      values.iv_sub_division = ''
      values.iv_office_code = ''
    }

  }
  const handleChangeSupportCenter = (event) => {
    handleChange(event);
    values.iv_office_code = event.target.value;
  };

  const handleChangeSubDivision = (event) => {
    handleChange(event);
    values.iv_office_code = event.target.value;
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setFormValues(true);
    }, 500);

    // Clear the timeout to prevent the state update if the component unmounts or userState changes
    return () => clearTimeout(timeoutId);
  }, [userState]);


  const errorCloses = () => {
    setError('')
  }


  const handleChangeRoleType = (event) => {

    setSelectedRoleType(event.target.value);
  };
  return (
    <>
      <Grid className='creation user-management-form'>
        <Grid container className='creationContainer'>
        <Grid item lg={12}>
          <h3 className='heading'>
            Update User
          </h3>
        </Grid>
        <Grid item lg={12} className='form'>
          <Grid container>
            <Grid item lg={12}>
              <Grid container spacing={1}>
                <Grid item lg={12}>
                  <h4>Basic Information</h4>
                </Grid>
                <Grid item lg={12}>
                  <Grid container className="org-form-profile-row">
                <Grid item className="org-logo-upload-col">
                  <Box className="org-logo-upload">
                    <Box className="org-logo-upload__ring">
                      <Box
                        component="img"
                        className={`org-logo-upload__image${file ? ' org-logo-upload__image--filled' : ''}`}
                        src={file ? URL.createObjectURL(file) : UserIconImage}
                        alt="Profile"
                        onError={(e) => {
                          e.target.src = UserIconImage;
                        }}
                      />
                      <Box
                        component="label"
                        htmlFor="update-user-profile-photo-input"
                        className="org-logo-upload__btn"
                      >
                        <DriveFolderUploadIcon sx={{ fontSize: 22, color: 'inherit' }} />
                      </Box>
                      <input
                        type="file"
                        id="update-user-profile-photo-input"
                        accept="image/jpeg,image/png,.jpg,.jpeg,.png"
                        onChange={(e) => setFile(e.target.files[0])}
                        style={{ display: "none" }}
                      />
                    </Box>
                    <Typography className="org-logo-upload__hint" variant="caption">
                      JPEG or PNG · max 3 MB
                    </Typography>
                  </Box>
                </Grid>
                <Grid item className="org-form-fields-col">
                  <Grid container >
                    <Grid item lg={3} sx={{ padding: '10px', display: 'flex', flexDirection: 'column' }}>
                      <label>Employee Type</label>
                      <FormControl className='form-control'>
                        <RadioGroup
                          row
                          name="roleType"
                          value={selectedRoleType}
                        // onChange={handleChangeRoleType}
                        >
                          <FormControlLabel value="1" control={<Radio disabled />} label="Commercial" />
                          <FormControlLabel value="2" control={<Radio disabled />} label="Technical" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '10px', display: 'flex', flexDirection: 'column' }}>
                      <label>Status</label>
                      <FormControl className='form-control'>
                        <RadioGroup
                          row
                          name="status"
                          value={selectedStatus}
                        >
                          <FormControlLabel value="true" control={<Radio disabled />} label="Active" />
                          <FormControlLabel value="false" control={<Radio disabled />} label="InActive" />
                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* <Grid item lg={3} sx={{ padding: '10px' }}>
                      <label>Status</label>
                      <Grid>
                        {
                          errors.iv_status && touched.iv_status ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_status}</p>
                          ) : null
                        }
                      </Grid>
                      <FormControl >
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="iv_status"
                          id="iv_status"
                          className='radio'
                          value={values.iv_status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <FormControlLabel value={1} className='option-left' sx={{ padding: '0px 22.5px', marginRight: '15px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Active' />
                          <FormControlLabel value={0} className='option-left' sx={{ padding: '0px 22.5px', backgroundColor: 'white', borderRadius: '5px', marginLeft: '0px', border: '1px solid lightgrey' }} control={<Radio />} label='Inactive' />
                        </RadioGroup>
                      </FormControl>
                    </Grid> */}
                    <Grid item lg={3} sx={{ padding: '10px' }}>
                      <label>Office Code</label>
                      <TextField type='number' maxLength='5' readOnly onChange={handleChange} name="iv_office_code" value={values.iv_office_code} onBlur={handleBlur} disabled sx={{
                        backgroundColor: '#EEF1F7', width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                    </Grid>
                    {/* <Grid item lg={3} sx={{ padding: '10px' }}>
                      <label>Level</label>
                      <Select
                        fullWidth
                        value={values.iv_level}
                        onChange={handleLevelChange}
                        sx={{ height: '45px', width: '100%' }}
                        onBlur={handleBlur}
                        name="iv_level"
                        id="iv_level"
                      >
                        <MenuItem >Select Level</MenuItem>
                        {
                          technicalLevels.map((item) =>
                            <MenuItem value={item.value}>{item.label}</MenuItem>)
                        }
                      </Select>
                      <Grid>
                        {
                          errors.iv_level && touched.iv_level ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid> */}

                    {
                      selectedRoleType == "1" &&
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Level</label>
                        <Select
                          fullWidth
                          value={values.iv_level}
                          onChange={handleLevelChange}
                          sx={{ height: '45px', width: '100%' }}
                          onBlur={handleBlur}
                          name="iv_level"
                          id="iv_level"
                        >
                          <MenuItem >Select Level</MenuItem>
                          {
                            cfcLevelList.map(item => <MenuItem value={item.cfcLevelId}>{item.cfcLevelName}</MenuItem>)
                          }
                        </Select>
                        <Grid>
                          {
                            errors.iv_level && touched.iv_level ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
                            ) : null
                          }
                        </Grid>
                      </Grid>
                    } {
                      selectedRoleType == "2" &&
                      <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Level</label>
                        <Select
                          fullWidth
                          value={values.iv_level}
                          onChange={handleLevelChange}
                          sx={{ height: '45px', width: '100%' }}
                          onBlur={handleBlur}
                          name="iv_level"
                          id="iv_level"
                        >
                          <MenuItem >Select Level</MenuItem>
                          {
                            technicalLevels.map(item => <MenuItem value={item.value}>{item.label}</MenuItem>)
                          }
                        </Select>
                        <Grid>
                          {
                            errors.iv_level && touched.iv_level ? (
                              <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
                            ) : null
                          }
                        </Grid>
                      </Grid>
                    }

                    {
                      values.iv_level > 1 ?
                        <>
                          <Grid item lg={3} sx={{ padding: '10px' }}>
                            <label>Company</label>
                            <Select
                              fullWidth
                              disabled={parseInt(hierarchy) != 1}
                              value={values.iv_company}
                              onChange={handleChangeCompany}
                              sx={{ height: '45px' }}
                              onBlur={handleBlur}
                              name="iv_company"
                              id="iv_company"
                            >
                              <MenuItem >Select Company</MenuItem>
                              {
                                values.iv_level > 1 ?
                                  companyList.map((item) =>
                                    item.code > 1 ?
                                      <MenuItem value={item.code}>{item.name}</MenuItem> : null) :
                                  companyList.map((item) =>
                                    <MenuItem value={item.code}>{item.name}</MenuItem>)
                              }
                            </Select>
                            <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                              {errors.iv_company && touched.iv_company ? (errors.iv_company) : null}
                            </Grid>
                          </Grid>
                        </> : null
                    }
                    {
                      values.iv_level > 2 ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Circle</label>
                          <Select
                            fullWidth
                            value={values.iv_circle}
                            onChange={handleChangeCircle}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_circle"
                            id="iv_circle"
                          >
                            <MenuItem>Select Circle</MenuItem>
                            {
                              circleList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_circle && touched.iv_circle ? (errors.iv_circle) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                    {
                      values.iv_level > 3 ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Division</label>
                          <Select
                            fullWidth
                            value={values.iv_division}
                            onChange={handleChangeDivision}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_division"
                            id="iv_division"
                          >
                            <MenuItem>Select Division</MenuItem>
                            {
                              divisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_division && touched.iv_division ? (errors.iv_division) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                    {
                      values.iv_level === 51 ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Customer Support Center</label>
                          <Select
                            fullWidth
                            value={values.iv_support_center}
                            onChange={handleChangeSupportCenter}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_support_center"
                            id="iv_support_center"
                          >
                            <MenuItem>Select Sub Division</MenuItem>
                            {
                              cfcsList.map(item => <MenuItem value={item.cfcId}>{item.cfcName}</MenuItem>)
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_support_center && touched.iv_support_center ? (errors.iv_support_center) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                    {
                      (values.iv_level === 52 || values.iv_level == 5) ?
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                          <label>Sub Division</label>
                          <Select
                            fullWidth
                            value={values.iv_sub_division}
                            onChange={handleChangeSubDivision}
                            sx={{ height: '45px' }}
                            onBlur={handleBlur}
                            //displayEmpty
                            name="iv_sub_division"
                            id="iv_sub_division"
                          >
                            <MenuItem>Select Sub Division</MenuItem>
                            {
                              subdivisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                            }
                          </Select>
                          <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_sub_division && touched.iv_sub_division ? (errors.iv_sub_division) : null}
                          </Grid>
                        </Grid>
                        : null
                    }
                  </Grid>
                </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12}>
              <Grid container spacing={1}>
                <Grid item lg={12}>
                  <h4>User Role</h4>
                </Grid>
                <Grid item lg={12} sx={{ padding: '0px 10px' }}>
                      {
                        values.iv_level &&
                        <>
                          <Grid>
                            {
                              errors.iv_role && touched.iv_role ? (
                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_role}</p>
                              ) : null
                            }
                          </Grid>
                        </>

                      }
                      {/* <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="iv_role"
                          id="iv_role"
                          value={values.iv_role}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <>
                            <Grid sx={{ width: '100%' }}>
                              {
                                allRoles && allRoles.map((item) => {
                                  const level = values.iv_level;

                                  if ((level === 4 && (item.level === 4 || item.level === 51)) || (level !== 4 && item.level === level)) {
                                    return (
                                      <FormControlLabel
                                        key={item.id}
                                        sx={{
                                          padding: '0px 22.5px',
                                          backgroundColor: 'white',
                                          borderRadius: '5px',
                                          marginLeft: '0px',
                                          border: '1px solid lightgrey',
                                          marginBottom: '10px'
                                        }}
                                        value={item.id}
                                        control={<Radio />}
                                        label={item.name}
                                      />
                                    );
                                  }

                                  return null;
                                })
                              }
                            </Grid>
                          </>
                        </RadioGroup>
                      </FormControl> */}
                      <FormControl fullWidth className='form-control'>
                        <RadioGroup
                          className='user-role-group'
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="iv_role"
                          id="iv_role"
                          value={isRoleManuallyChanged ? values.iv_role : selectedRoleId || ''}
                          onChange={(e) => {
                            setIsRoleManuallyChanged(true);
                            setFieldValue('iv_role', e.target.value);
                          }}
                          onBlur={handleBlur}
                        >
                          {allRoles && allRoles.map((item) => {
                                const level = values.iv_level;
                                const roleTypeId = selectedRoleType;

                                if (
                                  (
                                    level == 4 &&
                                    (item.level == 4 || item.level == 51 ) &&
                                    item.roleTypeId == roleTypeId
                                  ) ||
                                  (
                                    level != 4 &&
                                    item.level == level &&
                                    item.roleTypeId == roleTypeId
                                  )
                                ) {
                                  return (
                                    <FormControlLabel
                                      key={item.id}
                                      className='form-control-label'
                                      value={item.id}
                                      control={<Radio />}
                                      label={item.name}
                                    />
                                  );
                                }

                                return null;
                              })}
                        </RadioGroup>
                      </FormControl>

                    </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12}>
              <Grid container spacing={1}>
                <Grid item lg={12}>
                  <h4>User Information</h4>
                </Grid>
                <Grid item lg={12}>
                  <Grid container sx={{ padding: '0px 10px' }}>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Full Name</label>
                      <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_full_name" value={values.iv_full_name} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_full_name && touched.iv_full_name ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_full_name}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Username</label>
                      <TextField type='text' disabled autoComplete='off' onChange={handleChange} name="iv_user_name" value={values.iv_user_name} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />

                      {
                        errors.iv_user_name && touched.iv_user_name ? (
                          <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_user_name}</p>
                        ) : null
                      }

                    </Grid>
                    {/* <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Pin code</label>
                      <TextField type='text' autoComplete='off' maxLength='4' onChange={handleChange} name="iv_pin_code" value={values.iv_pin_code} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_pin_code && touched.iv_pin_code ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_pin_code}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid> */}
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Email Address</label>
                      <TextField type='text' autoComplete='off' onChange={handleChange} name="iv_email" value={values.iv_email} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_email && touched.iv_email ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_email}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Phone No.</label>
                      <TextField type='text' maxLength='11' autoComplete='off' onChange={handleChange} inputProps={{ maxLength: 11 }} name="iv_phone_no" value={values.iv_phone_no} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_phone_no && touched.iv_phone_no ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_phone_no}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>CNIC No.</label>
                      <TextField type='text' maxLength="13" autoComplete='off' onChange={handleChange} name="iv_cnic" inputProps={{ maxLength: 13 }} value={values.iv_cnic} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }} />
                      <Grid>
                        {
                          errors.iv_cnic && touched.iv_cnic ? (
                            <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_cnic}</p>
                          ) : null
                        }
                      </Grid>
                    </Grid>
                    {/* <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Password</label>
                      <TextField maxLength='16' type={showPassword ? 'text' : 'password'} autoComplete='off' onChange={handleChange} name="iv_password" value={values.iv_password} onBlur={handleBlur} sx={{
                        width: '100%', '.MuiInputBase-input': {
                          height: '1vh',
                        },
                      }}
                        InputProps={{
                          endAdornment: (
                            (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end">

                                  {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          ),
                        }}
                      />
                      <Grid>
                        {touched.iv_password && errors.iv_password && (
                          <ul style={{ color: '#f73232', fontSize: '0.9rem', paddingLeft: '1.2rem', marginTop: '4px' }}>
                            {Array.isArray(errors.iv_password) ? (
                              errors.iv_password.map((err, idx) => <li key={idx}>{err}</li>)
                            ) : (
                              <li>{errors.iv_password}</li>
                            )}
                          </ul>
                        )}

                      </Grid>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '0px 10px' }}>
                      <label>Password Confirmation</label>
                      <TextField
                        maxLength="16"
                        type={showConfirmPassword ? 'text' : 'password'}
                        autoComplete="off"
                        onChange={handleChange}
                        name="iv_confirm_password"
                        value={values.iv_confirm_password}
                        onBlur={handleBlur}
                        sx={{
                          width: '100%',
                          '.MuiInputBase-input': {
                            height: '1vh',
                          },
                        }}
                        InputProps={{
                          endAdornment: (
                            (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle confirm password visibility"
                                  onClick={handleClickShowConfirmPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            )
                          ),
                        }}
                      />
                      <Grid>
                        {errors.iv_confirm_password && touched.iv_confirm_password ? (
                          <p style={{ color: '#f73232', fontSize: '1rem' }}>
                            {errors.iv_confirm_password}
                          </p>
                        ) : null}
                      </Grid>
                    </Grid> */}
                    {error ? (
                      <Grid item lg={12} sx={{ margin: '0px 20px 0px 10px' }}>
                        <Error
                          error={error}
                          onClose={() => errorCloses()}
                          backgroundColor="#FFC0CB"
                          textColor="#bb0303"
                          iconColor="#bb0303"
                        />
                      </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid container className="org-form-actions">
              <Grid item lg={12} sx={{ textAlign: 'right' }}>
                <Button variant="contained" size='medium' onClick={handleSubmit}>
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        </Grid>
      </Grid>

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >

    </>
  )
}

export default UserUpdateForm;